// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"e_-s","scoreNumber":"e_at","scoreStars":"e_bt","badge":"e_ct","badgeImage":"e_dt"};